import { render } from "./navigation-link.vue?vue&type=template&id=0f6c8d24"
import script from "./navigation-link.vue?vue&type=script&lang=js"
export * from "./navigation-link.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__